// src/components/MuiComponents/ErrorBanner.js
import React from 'react';
import InfoIcon from '@mui/icons-material/Info';

export default function ErrorBanner({ id, message, className = '' }) {
  if (!message) return null;

  return (
    <div
      id={id}
      role="alert"
      className={`error-banner ${className}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginTop: 4,
        padding: '6px 8px',
        borderRadius: 6,
        background: 'rgba(220, 38, 38, 0.08)', // light red bg
        border: '1px solid var(--functional-red)',
        color: 'var(--functional-black)',
        lineHeight: 1.3,
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      <InfoIcon
        fontSize="small"
        sx={{ color: 'var(--functional-red)', marginTop: '1px' }}
      />
      <span>{typeof message === 'string' ? message : message}</span>
    </div>
  );
}